import { Dayjs } from 'dayjs';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import DistributionType from '../../enums/@shared/DistributionType';
import { Authentication } from '@leedpulse-monorepo/classes';
import Subscription from '../../models/Subscription';

async function importContacts(
  payload: ImportContactsPayload,
  auth: Authentication
): Promise<any> {
  try {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append("fileMapping", JSON.stringify(payload.uploadedFileMapping));
    formData.append('fileAuto', payload.distribution);
    formData.append('fileOwner', payload.owner);
    formData.append('subscriptionId', payload.subscription.id);
    formData.append('fileProspectCategory', payload.contactCategory);
    formData.append('importedBy', auth.id);
    formData.append('contactScheduled', String(payload.contactScheduled));
    if (payload.contactScheduledDate) {
      const contactScheduledTimestamp = payload.contactScheduledDate.valueOf();
      formData.append('contactScheduledTimestamp', String(contactScheduledTimestamp));
    }

    return await HttpClient.post('/contacts/file', formData, auth.token, true, {
      'x-api-key': payload.subscription.apiKey,
      'x-sender': payload.sender,
    });
  } catch (e: any) {
    console.log('error: ', e);
    
    const errorMessage = e.message || 'Unknown error';
    throw new ImportContactsFailure(errorMessage, 'import-error');
  }
}

export class ImportContactsPayload {
  subscription: Subscription;
  file: File;
  distribution: DistributionType;
  owner: string;
  sender: string;
  contactCategory: string;
  uploadedFileMapping: any[];
  contactScheduled: boolean;
  contactScheduledDate: Dayjs | null;

  constructor(
    subscription: Subscription,
    file: File,
    distribution: DistributionType,
    owner: string,
    sender: string,
    contactCategory: string,
    uploadedFileMapping: any[],
    contactScheduled: boolean,
    contactScheduledDate: Dayjs | null
  ) {
    this.subscription = subscription;
    this.file = file;
    this.distribution = distribution;
    this.owner = owner;
    this.sender = sender;
    this.contactCategory = contactCategory;
    this.uploadedFileMapping = uploadedFileMapping;
    this.contactScheduled = contactScheduled;
    this.contactScheduledDate = contactScheduledDate;
  }
}

export class ImportContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default importContacts;
